<template>
  <div id="aprication">
    <div class="headerp-div">
      <div class="header-div">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="header-div" style="text-align: right">
        <el-button size="mini" v-if="$hasPerm('system:app:add')" @click="handleAdd()" style=";background-color:#16E3A1;color: white">新增<i class="el-icon-plus"></i></el-button>
      </div>
    </div>
    <el-table :data="tableData" border size="medium" style="width: 100%">
      <el-table-column prop="name" label="应用名称" style="width: 25%"></el-table-column>
      <el-table-column prop="code" label="应用编码" style="width: 25%"></el-table-column>
      <el-table-column prop="sort" label="排序" style="width: 25%"></el-table-column>
      <el-table-column prop="isEnable" label="是否启用" :formatter="dateFormat" style="width: 25%"></el-table-column>
      <el-table-column label="操作" v-if="$hasPerm('system:app:edit,system:app:remove')">
        <template slot-scope="scope">
          <el-button size="mini" style="margin-right: 5px;" v-if="$hasPerm('system:app:edit')" @click="handleEdit(scope.$index, scope.row)">编辑<i class="el-icon-edit"></i></el-button>
          <el-popconfirm title="确定删除吗？" @onConfirm="handleDelete(scope.$index, scope.row)">
            <el-button size="mini" slot="reference" v-if="$hasPerm('system:app:remove')" type="danger">删除<i class="el-icon-delete"></i></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
    background
    layout="total, sizes, prev, pager, next, jumper"
    :total="total"
    :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
    :page-size="pageSize"
    :current-page="currentPage"
    @current-change="handleCurrentChange"
    @size-change="handleSizeChange"
    ></el-pagination>
    <edit v-if="editVisible" ref="edit" @handleCurrentChange="handleCurrentChange"></edit>
  </div>
</template>
<script>
    import Edit from './edit'
    export default {
      name: 'AppList',
      components:{
        Edit
      },
      data() {
        return {
          currentPage: 1, //初始页
          pageSize: 10, //    每页的数据
          total: 0,
          offset: 0,
          tableData: [],
          editVisible: false
        }
      },
      methods: {
        handleCurrentChange(cPage) {
          this.offset = (cPage-1)*this.pageSize;
          this.$httpTAG({
            url: this.$httpTAG.adornUrl('/business/system/app/list'),
            method: 'get',
            params: this.$httpTAG.adornParams({
              'offset': this.offset,
              'limit': this.pageSize
            })
          }).then(r => {
            this.tableData = r.data.data.rows;
            this.total = r.data.data.total;
          }).finally(r => {})
        },
        handleSizeChange(val) {
          this.pageSize = val;
          this.handleCurrentChange(1);
        },
        //时间格式化
        dateFormat:function(row,column){
          let date = row[column.property];
          if(date == 1){return '是'}
          if(date == 0){return '否'}
          return date;
        },
        handleAdd() {
          this.editVisible = true;
          this.$nextTick(()=>{
            this.$refs.edit.int("add");
          })
        },
        handleEdit(index, row) {
          this.editVisible = true;
          this.$nextTick(()=>{
            this.$refs.edit.int(row.uuid);
          })
        },
        handleDelete(index, row) {
          let uuid = row.uuid;
          this.$httpTAG({
            url: this.$httpTAG.adornUrl('/business/system/app/remove'),
            method: 'post',
            data: this.$httpTAG.adornData({
              'uuid': uuid
            })
          }).then(res => {
            if (res.data.code == 0) {
              this.$notify({
                title: '操作成功！',
                type: 'success',
                offset: 600
              });
              this.handleCurrentChange(1);
            } else {
              this.$message({ // 失败
                type: 'error',
                message: res.data.msg
              })
            }
          }).finally(r => {})

        }
      },
      created: function() {
        this.handleCurrentChange(this.currentPage);
      }
    }
</script>
<style scoped>
  .header-div{
    margin-bottom: 5px;
    float: left;
    width: 50%;
  }
</style>
